module.exports = __webpack_public_path__ + "static/img/dog-3.74358fdc.png";